document.addEventListener('DOMContentLoaded', function(){
    const currentHash = document.location.hash;
    if(currentHash == '#upsale=1' && upsale_product_in_cart == true) {
        $('.upsale-overlay, .upsale-popup').show();
        $('body').addClass('body-overflow-hidden');
    }

    if(currentHash == '#notify-me-when-available') {
        setTimeout(function() {
            const bisButton = document.querySelector('#klaviyo-bis-trigger');
            if (bisButton) {
                bisButton.click();
            }
        }, 500);
    }

    $(".star-rating-block").click(function (){
        $('html, body').animate({
            scrollTop: $("#customers-review-section").offset().top-100
        }, 2000);
    });

    const documentHeight = $(window).height();
    const documentWidth = $(window).width();

    if(documentHeight < 800 && documentWidth > 1024){
        $('.mainGallery').css('height', documentHeight-250+'px');
    }

    if(typeof showMoreDescription != 'undefined' && showMoreDescription != false) {
        /*Product Info Section*/
        const actionBtn = document.getElementById("show-full-description");
        const actionBtnMobile = document.getElementById("show-full-description_m");
        const shortDesc = document.getElementById("short-description");
        const shortDescMobile = document.getElementById("short-description_m");
        const fullDesc = document.getElementById("full-description");

        actionBtn.addEventListener("click", function () {
            if (fullDesc.classList.contains("tw_hidden")) {
                shortDesc.style.display = "none";
                fullDesc.classList.remove("tw_hidden");
                actionBtn.textContent = "Show Less";
            } else {
                shortDesc.style.display = "inline-block";
                fullDesc.classList.add("tw_hidden");
                actionBtn.textContent = "Show More";
            }
        });

        actionBtnMobile.addEventListener("click", function () {
            if (fullDesc.classList.contains("tw_hidden")) {
                shortDescMobile.style.display = "none";
                fullDesc.classList.remove("tw_hidden");
                actionBtnMobile.textContent = "Show Less";
            } else {
                shortDescMobile.style.display = "inline-block";
                fullDesc.classList.add("tw_hidden");
                actionBtnMobile.textContent = "Show More";
            }
        });
    }

    /*Main Images Slider*/
    let swiper = new Swiper(".thumbsGallery", {
        loop: true,
        spaceBetween: 16,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
        pagination: {
            el: ".swiper-pagination.swiper-thumbsGallery-pagination",
        },
    });
    window.productSwiper = new Swiper(".mainGallery", {
        loop: true,
        spaceBetween: 10,
        navigation: {
            nextEl: ".mainGallery .swiper-button-next",
            prevEl: ".mainGallery .swiper-button-prev",
        },
        thumbs: {
            swiper: swiper,
        },
    });

    $(window).scroll(function () {
        let viewportTop = $(window).scrollTop();
        let documentWidth = $(document).width();
        if(viewportTop > 396 && documentWidth > 1279) {
            $('#header-add-to-cart-btn').fadeIn(500);
        } else {
            $('#header-add-to-cart-btn').fadeOut(500);
        }
        if(viewportTop > 496 && documentWidth < 1280) {
            $('#header-add-to-cart-btn-m').fadeIn(500);
        } else {
            $('#header-add-to-cart-btn-m').fadeOut(500);
        }
    });

});


function openAffirmPopup() {
    $('.affirm-modal-trigger').click();
}


